"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentImprovements = void 0;
exports.documentImprovements = {
    numRows: 30,
    columnNames: [
        "Key",
        "Epic Query Template",
        "Error Code",
        "Documentation Improvement Opportunity Description",
        "Send Query"
    ],
    rowValues: [
        {
            "Documentation Improvement Opportunity Description": "Attestation Discrepancy (Procedure vs. E&M)",
            "Send Query": "Yes",
            "Epic Query Template": "Attestation Discrepancy",
            Key: "1",
            "Error Code": "X2"
        },
        {
            "Documentation Improvement Opportunity Description": 'Attestation/Shared-Exam clarification-Query used when  resident/APP has no face to face with the patient due to covid protocol and the sr. staff has an "I saw and evaluated" attestation with no other patient interaction indicated',
            "Send Query": "Yes",
            "Epic Query Template": ".IPCATTESTATIONSHAREDEXAMCLARIFICATION",
            Key: "2",
            "Error Code": "AC"
        },
        {
            "Documentation Improvement Opportunity Description": "Personal Statement Incorrect (E&M)",
            "Send Query": "Yes",
            "Epic Query Template": "Personal Statement Incorrect",
            Key: "3",
            "Error Code": "A3"
        },
        {
            "Documentation Improvement Opportunity Description": "Shared Visit Attestation incorrect (APP notes)",
            "Send Query": "Yes",
            "Epic Query Template": "Shared visit attestation incorrect (2023)",
            Key: "4",
            "Error Code": "A7"
        },
        {
            "Documentation Improvement Opportunity Description": "LOS: Missing note - E&M or Procedure (Incomplete Note)",
            "Send Query": "Yes",
            "Epic Query Template": "Missing or incomplete note or procedure (2023)",
            Key: "5",
            "Error Code": "Y1"
        },
        {
            "Documentation Improvement Opportunity Description": "Missing medically appropriate Hx or Exam",
            "Send Query": "Yes",
            "Epic Query Template": "Component of visit missing",
            Key: "6",
            "Error Code": "HE"
        },
        {
            "Documentation Improvement Opportunity Description": "Discussion planned but not documented as done",
            "Send Query": "Yes",
            "Epic Query Template": "Component of visit missing",
            Key: "7",
            "Error Code": "J7"
        },
        {
            "Documentation Improvement Opportunity Description": "App or sr. staff is primary author with no face to face",
            "Send Query": "Yes",
            "Epic Query Template": "APP or sr. staff is primary author with no face to face",
            Key: "8",
            "Error Code": "F3"
        },
        {
            "Documentation Improvement Opportunity Description": "No Dx given or assigned",
            "Send Query": "Yes",
            "Epic Query Template": "Component of visit missing",
            Key: "9",
            "Error Code": "D7"
        },
        {
            "Documentation Improvement Opportunity Description": "MDM: Missing",
            "Send Query": "Yes",
            "Epic Query Template": "Component of visit missing",
            Key: "10",
            "Error Code": "J4"
        },
        {
            "Documentation Improvement Opportunity Description": "Problem list not updated at all",
            "Send Query": "Yes",
            "Epic Query Template": "Component of visit missing",
            Key: "11",
            "Error Code": "J5"
        },
        {
            "Documentation Improvement Opportunity Description": "LOS: Required documentation of time missing",
            "Send Query": "Yes",
            "Epic Query Template": "Time missing required documentation",
            Key: "12",
            "Error Code": "R1"
        },
        {
            "Documentation Improvement Opportunity Description": "Attestation Missing (see X9 first)",
            "Send Query": "Yes",
            "Epic Query Template": "Missing Attestation",
            Key: "13",
            "Error Code": "A1"
        },
        {
            "Documentation Improvement Opportunity Description": "Patient Status incorrect (no order)",
            "Send Query": "Yes/No",
            "Epic Query Template": "Patient status incorrect (no order)",
            Key: "14",
            "Error Code": "U1"
        },
        {
            "Documentation Improvement Opportunity Description": 'Medicaid telehealth service-audio only with patient-Informational needed for claim-"services provided via telephone"',
            "Send Query": "No",
            Key: "15",
            "Epic Query Template": "",
            "Error Code": "CC"
        },
        {
            "Documentation Improvement Opportunity Description": "Frequency exceeded-9902D due to frequency limitations of interpersonal or telephone based services or cannot bill interpersonal or telephone due to in person visit within qualifying period",
            "Send Query": "No",
            Key: "16",
            "Epic Query Template": "",
            "Error Code": "FE"
        },
        {
            "Documentation Improvement Opportunity Description": "COVID-19 related-non actionable-In person not performed or elements not performed or lacking due to the COVID-19 situation.   Requires a potential level of service (can be used on own or as add on)",
            "Send Query": "No",
            Key: "17",
            "Epic Query Template": "",
            "Error Code": "C9"
        },
        {
            "Documentation Improvement Opportunity Description": "Not Queried-Attestation Missing",
            "Send Query": "No-Log",
            "Epic Query Template": "Query not sent.  Progress to A1, X2, A3, or X4",
            Key: "18",
            "Error Code": "X9"
        },
        {
            "Documentation Improvement Opportunity Description": "Shared Hold-Holding for potential staff participation",
            "Send Query": "No-Log",
            "Epic Query Template": "Query not sent.  Progress to VZ or A7",
            Key: "19",
            "Error Code": "V9"
        },
        {
            "Documentation Improvement Opportunity Description": "Attested as reviewed, not present, or cosignature only",
            "Send Query": "No",
            Key: "20",
            "Epic Query Template": "",
            "Error Code": "X4"
        },
        {
            "Documentation Improvement Opportunity Description": "Dropped Dx",
            "Send Query": "No",
            Key: "21",
            "Epic Query Template": "",
            "Error Code": "D1"
        },
        {
            "Documentation Improvement Opportunity Description": "Problem list partially updated",
            "Send Query": "No",
            Key: "22",
            "Epic Query Template": "",
            "Error Code": "J6"
        },
        {
            "Documentation Improvement Opportunity Description": "Consult no requestor",
            "Send Query": "No",
            Key: "23",
            "Epic Query Template": "",
            "Error Code": "P1"
        },
        {
            "Documentation Improvement Opportunity Description": "Inappropriate use of other author's documentation (Incl cloning w/ approv)",
            "Send Query": "No",
            "Epic Query Template": "",
            Key: "24",
            "Error Code": "S5"
        },
        {
            "Documentation Improvement Opportunity Description": "Unable to use medical student documentation (results in a missing note)-Billed as 9902D, add potential",
            "Send Query": "No",
            "Epic Query Template": "",
            Key: "25",
            "Error Code": "MS"
        },
        {
            "Documentation Improvement Opportunity Description": "Reviewed Documentation/Test Result (internal use only)-no opportunity-no intention of face to face",
            "Send Query": "No",
            "Epic Query Template": "",
            Key: "26",
            "Error Code": "Q1"
        },
        {
            "Documentation Improvement Opportunity Description": "Potential ITM",
            "Send Query": "No",
            "Epic Query Template": "",
            Key: "27",
            "Error Code": "J8"
        },
        {
            "Documentation Improvement Opportunity Description": "Potentially overlapping time carved out as APP did not designate time as excluding shared time with the physician",
            "Send Query": "No",
            "Epic Query Template": "",
            Key: "28",
            "Error Code": "R4"
        },
        {
            "Documentation Improvement Opportunity Description": "Multiple visits same date, not clear if time in later note is inclusive of earlier time or additive/independent of earlier time",
            "Send Query": "No",
            "Epic Query Template": "",
            Key: "29",
            "Error Code": "R5"
        },
        {
            "Documentation Improvement Opportunity Description": "Neither resident or sr. staff with face-to-face resulting in 9902D",
            "Send Query": "No",
            "Epic Query Template": "",
            Key: "30",
            "Error Code": "F4"
        }
    ]
};
//# sourceMappingURL=documentation-improvements.js.map